import React from 'react';
import { Styled } from './Paragraph.styled';

type Props = {
  color?: string;
};

const Paragraph: React.FC<Props> = ({ children, color = '#969a9f' }) => {
  return <Styled color={color}>{children}</Styled>;
};

export default Paragraph;
